import { FETCH_NOTIFICATIONS, SELECT_NOTIFICATION } from "actions/types";
import { arrayToObjectIndexedById } from "reducers/utils";

export const defaultState = {
  notifications: {},
  activeNotificationId: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SELECT_NOTIFICATION:
      return { ...state, activeNotificationId: action.payload };

    case FETCH_NOTIFICATIONS:
      return { ...state, notifications: arrayToObjectIndexedById(action.payload) };

    default:
      return state;
  }
};

export const activeProductSelector = ({ notifications, activeProductId }) => {
  if (activeProductId) {
    return notifications[activeProductId];
  }
};

export const notificationsSelector = state => {
  return Object.values(state.notifications);
};
